module.exports = __webpack_public_path__ + "img/icon_report_empty_logo_4.35c4ed7b.png";